import { GiftOrderRequest } from '@models/gift';
import {
  ChangeEvent, createContext, Dispatch, SetStateAction,
} from 'react';

export type GiftFormProps = Pick<GiftOrderRequest, 'userName' | 'userPhone' | 'giftRecipients' | 'message' | 'cardName'>;

export interface ContextProps {
    state: GiftFormProps;
    setState: Dispatch<SetStateAction<GiftFormProps>>;
    handleChange?: (e: ChangeEvent<HTMLInputElement>) => void;
    enabled: boolean;
}

const GiftOrderContext = createContext<ContextProps>({} as ContextProps);

export default GiftOrderContext;
